import { render, staticRenderFns } from "./HubDocuments.vue?vue&type=template&id=571ed134&"
import script from "./HubDocuments.vue?vue&type=script&lang=js&"
export * from "./HubDocuments.vue?vue&type=script&lang=js&"
import style0 from "./HubDocuments.vue?vue&type=style&index=0&id=571ed134&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports